<div class="form-box-header flex-row">
	<div *ngIf="IconName" class="form-box-header-icon">
		<span class="icon {{IconCssId}}">{{IconName}}</span>
	</div>
	<div class="form-box-header-text flex-col">
		<div class="title">{{Title}}</div>
		<div *ngIf="SubTitle" class="sub-title">{{SubTitle}}</div>
	</div>
</div>